import script from "./TermsConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsConditions.vue?vue&type=script&setup=true&lang=ts"

import "./TermsConditions.vue?vue&type=style&index=0&id=2270617b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2270617b"]])

export default __exports__